import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// import CsvDownloader from 'react-csv-downloader';
import { Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import queryString from 'query-string';

import { TableList } from 'components/table-list';
import PdButton from 'components/pd-button';
import PdCsvDownloader from 'components/pd-csv-downloader';
import StatusList from 'components/list-status';

import { ORDER_STATUS_FILTER_LIST, priceFormat } from 'utils';

const { Title } = Typography;

/**
 *
 * @param {() => {}} fetchOrderForDownload - function hit BE API to fetch order data to download based on order data in table
 * @param {[Object]} orderForDownload - array of object contains order data to download
 * @param {[]} orderList - order data for table
 * @param {() => {}} orderLoad - function to fetch order data table
 * @param {() => {}} orderNext - function when button next is triggered
 * @param {() => {}} loadMoreOrder - function when button load more is triggered
 */

const Orders = ({
  fetchOrderForDownload,
  orderForDownload,
  orderList,
  orderLoad,
  orderNext,
  loadMoreOrder,
}) => {
  const [status, setStatus] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const parsed = queryString.parse(location.search);

  const detailBtn = (row) => (
    <div className="button-table">
      <Link to={`/orders/detail?id=${row.id}`}>
        <PdButton className="detail-button" type="primary">
          See Detail
        </PdButton>
      </Link>
    </div>
  );

  const invoiceField = (invoice) => {
    if (invoice) return invoice;
    else return <span>-</span>;
  };

  const orderColumns = [
    {
      name: 'Invoice No',
      selector: row => row.invoice_number,
      format: (row) => invoiceField(get(row, 'invoice_number', '')),
      width: '18%',
    },
    {
      name: 'Date',
      selector: row => row.ordered_at,
      format: (row) => dayjs(get(row, 'ordered_at', '')).format('DD/MM/YYYY'),
      width: '15%',
    },
    {
      name: 'Recipient',
      selector: row => row.user.full_name,
      width: '17%',
    },
    {
      name: 'Amount',
      selector: row => row.net_price,
      width: '18%',
      format: (row) => `IDR  ${priceFormat(get(row, 'net_price', ''))}`,
    },
    {
      name: 'Status',
      selector: row => row.status,
      width: '12%',
    },
    {
      name: '',
      cell: detailBtn,
      center: true,
      width: '20%',
    },
  ];

  function filterOrder(param, val) {
    if (!val) delete parsed[param];
    else parsed[param] = val;

    navigate('/resellers_active/detail?${stringified}', { replace: true });
  }

  async function handleDownloadCsv() {
    return await fetchOrderForDownload();
  }

  useEffect(() => {
    if (parsed['order_status']) setStatus(parsed['order_status']);
    else setStatus('');
  }, [parsed]);

  return (
    <Col lg={24} className="section-container">
      <div className=" inner-section">
        <Row className="summaryContent">
          <Title className="pageSubtitle" level={3}>
            Orders
          </Title>
          <Col lg={24}>
            <Col lg={4} className="mt-2">
              <span>Filter by Status:</span>
            </Col>
            <Col lg={13} className="mt-1">
              <StatusList
                onChange={filterOrder.bind(this, 'order_status')}
                selectedStatus={status}
                statusList={ORDER_STATUS_FILTER_LIST}
              />
            </Col>
            <Col lg={{ span: 4, offset: 2 }} className="pd-margin-top-md">
              {orderList.length > 0 && (
                <PdCsvDownloader
                  datas={handleDownloadCsv}
                  filename={get(
                    orderForDownload,
                    'store_name',
                    'order-data-homestory'
                  )}
                />
              )}
            </Col>
          </Col>
          <Col lg={24} className="pd-margin-top-md pd-reseller-detail-table">
            <TableList columns={orderColumns} orderList={orderList} />
          </Col>
          <Col lg={{ span: 3, offset: 10 }}>
            {orderNext > 0 && (
              <PdButton
                onClick={loadMoreOrder.bind(this, true)}
                outline={true}
                type="primary">
                {orderLoad ? 'Loading...' : 'Load More'}
              </PdButton>
            )}
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default Orders;
